import React, { Component } from 'react';
import { node, string, bool } from 'prop-types';
import ReactDOM from 'react-dom';

import SlideInOutTransition from './components/SlideInOutTransition';
import styles from './AnimatedCard.scss';

export default class AnimatedCard extends Component {
  static propTypes = {
    activeCard: string.isRequired,
    children: node.isRequired,
    animate: bool,
    toRight: bool,
  };

  static defaultProps = {
    toRight: false,
    animate: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    };
    this.cards = {};
  }

  componentDidMount() {
    if (this.props.animate) {
      this.setCardHeight(this.props.activeCard);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { activeCard, animate } = nextProps;

    if (activeCard === this.props.activeCard || !animate) {
      return;
    }

    const { height: previousHeight } = this.state;

    const { height } = ReactDOM.findDOMNode(
      this.cards[activeCard]
    ).getBoundingClientRect();

    if (previousHeight > height) {
      setTimeout(() => {
        this.setCardHeight(activeCard);
      }, 500);
    } else {
      this.setCardHeight(activeCard);
    }
  }

  setCardHeight = activeCard => {
    const { height } = ReactDOM.findDOMNode(
      this.cards[activeCard]
    ).getBoundingClientRect();

    this.setState({
      height,
    });
  };

  render() {
    const { children, activeCard, animate, toRight } = this.props;

    const { height } = this.state;

    const childrenKeyArr = React.Children.map(children, child => child.key);

    const childrenArr = React.Children.toArray(children);
    const activeKeyIndex = childrenKeyArr.findIndex(key => key === activeCard);

    const ActiveComponent = childrenArr[activeKeyIndex];

    return (
      <div
        className={styles.root}
        style={{
          minHeight: height ? `${height}px` : 'auto',
        }}
      >
        {animate ? (
          React.Children.map(children, child => (
            <SlideInOutTransition
              ref={node => {
                this.cards[child.key] = node;
              }}
              in={activeCard === child.key}
              toRight={toRight}
            >
              {child}
            </SlideInOutTransition>
          ))
        ) : (
          <div>{ActiveComponent}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/authCard/AnimatedCard/AnimatedCard.jsx